/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AuthSendPasswordResetEmail200Response
 */
export interface AuthSendPasswordResetEmail200Response {
    /**
     * 
     * @type {boolean}
     * @memberof AuthSendPasswordResetEmail200Response
     */
    success?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AuthSendPasswordResetEmail200Response
     */
    message?: string;
}

/**
 * Check if a given object implements the AuthSendPasswordResetEmail200Response interface.
 */
export function instanceOfAuthSendPasswordResetEmail200Response(value: object): value is AuthSendPasswordResetEmail200Response {
    return true;
}

export function AuthSendPasswordResetEmail200ResponseFromJSON(json: any): AuthSendPasswordResetEmail200Response {
    return AuthSendPasswordResetEmail200ResponseFromJSONTyped(json, false);
}

export function AuthSendPasswordResetEmail200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthSendPasswordResetEmail200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function AuthSendPasswordResetEmail200ResponseToJSON(json: any): AuthSendPasswordResetEmail200Response {
    return AuthSendPasswordResetEmail200ResponseToJSONTyped(json, false);
}

export function AuthSendPasswordResetEmail200ResponseToJSONTyped(value?: AuthSendPasswordResetEmail200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
    };
}

